<template>
  <div class="youtube-embed" v-if="youTubeVideoId.length > 0">
    <iframe class="youtube-embed__iframe" :src="`https://www.youtube.com/embed/${youTubeVideoId}`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </div>
</template>

<script lang="ts">
import {
  Component,
  Prop,
  Provide,
  Vue,
  Watch
} from 'vue-property-decorator';

@Component
export default class YouTubeComponent extends Vue {
  @Prop({ default: '' })
  public youTubeVideoId!: string;
}
</script>
